import { EditableGrid, EditorField } from "@/components/common/EditableGrid";
import { ShowAccordionSection } from "@/components/common/ShowAccordionSection";
import { ResourceName } from "@/types";

export const ClaimItemProcessingStatus = () => {
  const claimItemFields: EditorField[] = [
    { source: "claim_status", type: "readonly" },
    { source: "paid_date", type: "date" },
    { source: "check_number" },
  ];

  return (
    <ShowAccordionSection label="Processing Status" defaultExpanded>
      <EditableGrid fields={claimItemFields} recordType={ResourceName.CLAIM_ITEMS} />
    </ShowAccordionSection>
  );
};
